"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var urls = require('common/urls');
var bilnrsCtrl = function($scope, $uibModalInstance, $q, $http, bildnrsParams) {
  var init = function() {
    $scope.urls = urls;
    $scope.bildnr = bildnrsParams.bildnr;
    $scope.query = "";
    $scope.per_page = 6;
    $scope.page = 1;
    $scope.count = 0;
    getList();
  };
  $scope.selectPictureId = function(id) {
    angular.forEach($scope.pictures, function(value, key) {
      value.isSelected = false;
      if (value.id == id) {
        value.isSelected = true;
      }
    });
  };
  $scope.$watch('showBildnrs', function() {
    if ($scope.showBildnrs == true) {
      init();
    }
  });
  $scope.refresh = function() {
    $scope.page = 1;
    getList();
  };
  $scope.save = function() {
    var picture = null;
    angular.forEach($scope.pictures, function(value, key) {
      if (value.isSelected == true) {
        picture = value;
      }
    });
    $uibModalInstance.close(picture);
  };
  $scope.$watch('page', function() {
    getList();
  });
  var getList = function() {
    $scope.loading = true;
    var params = {
      "query": $scope.query,
      "page": $scope.page,
      "per_page": $scope.per_page
    };
    $http.get('/api/dia.json', {params: params}).success(function(data, status, headers, config) {
      $scope.pictures = data.pictures;
      $scope.count = data.count;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
      $scope.selectPictureId($scope.identifier);
    });
  };
  init();
};
bilnrsCtrl.$inject = ['$scope', '$uibModalInstance', '$q', '$http', 'bildnrsParams'];
module.exports = bilnrsCtrl;
